module.exports = __webpack_public_path__ + "fonts/icons/cm-icons.svg?a0ac635278c9af07b822b8f44c236dc7";